import { Box, Button, Typography } from '@mui/material';

import { TitleComponent } from '../Mobile/components/TitleComponent';

//hooks
import { useGlobalState } from '../../../Utilidades/useGlobalState';
import { useActionDispatch } from '../hooks/useActionDispatch';

import { PAGINA_UNO } from '../rutas';

//activos
import LogoClassLimitless from '../../../Activos/Icons/LogoClassLimitless';

import { styledCss } from '../Mobile/styles/customStyles';

export const HomePageMobile = () => {

   const { handleNavigationPage } = useActionDispatch()
   const { etiquetas } =  useGlobalState();

   const registerStart = () => {

      handleNavigationPage(PAGINA_UNO)
   }


   return  (
      <>
       
       <TitleComponent
        fontSize={32}
        textTitle={etiquetas.Home.Et_lblRegistro} />

        <Box sx={{display:'flex', marginTop:'65px', justifyContent:'center'}}>
          <LogoClassLimitless/>
        </Box>

        <Box sx={{display:'flex', alignItems:'center', flexDirection:'column', marginTop:'16px', justifyContent:'center'}}>
          <Typography component={"b"} sx={{ ...styledCss.h2, lineHeight:"120%"}}>
            {etiquetas.Home.Et_lblHola}
          </Typography>
          <Typography sx={{ ...styledCss.h3, width:"75%", lineHeight:"120%"}}>
             {etiquetas.Home.Et_lblSaludosDia}
          </Typography>
        </Box>
        
        <Box sx={{display:'flex', alignItems:'center', marginTop:'35px', justifyContent:'center'}}>
          <Typography sx={{ ...styledCss.h4, width:"75%", lineHeight:"152.4%"}}>
             {etiquetas.Home.Et_lblDescripcion}
           </Typography>
         </Box>

         <Box sx={{display:'flex', alignItems:'center', marginTop:'24px', justifyContent:'center'}}>
            <Button onClick={registerStart} variant='contained' sx={{...styledCss.buttonPrimary, }}>
               {etiquetas.Home.Et_lblcomenzar}
            </Button>
         </Box>

      </>
   )
}